import { RequestsCopy } from '@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests-copy'

const missionsCopy = {
  'page.missions.title': 'Manage missions',
  'page.mission.status.approved': 'Approved',
  'page.mission.status.pending': 'Pending',
  'page.mission.status.rejected': 'Rejected',
  'page.mission.frequency.one-off': 'One off',
  'page.mission.frequency.regular': 'Regular',
  'page.missions.table.header.name.desktop': 'Mission name',
  'page.missions.table.header.name.mobile': 'Name',
  'page.missions.table.header.time-pending': 'Time pending',
  'page.missions.table.header.task-type': 'Task type',
  'page.missions.table.header.frequency': 'Frequency',
  'page.missions.table.header.created-by.desktop': 'Created by',
  'page.missions.table.header.created-by.mobile': 'Volunteer',
  'page.missions.table.btn.view-action.desktop': 'View mission',
  'page.missions.table.btn.view-action.mobile': 'View',
  'page.mission.tabs.action': 'Mission',
  'page.mission.tabs.beneficiary': 'Beneficiary',
  'page.mission.tabs.user': 'User',
  'page.missions.button.refresh': 'Refresh',
  'page.missions.user.profile-picture': 'Profile picture of {user}',
  'page.missions.table.error': 'There was a problem loading missions. Please try again.',
  'page.missions.table.empty': 'There are no missions to display.',
}

const missionDetailsCopy = {
  'page.missions.details.tab.overview': 'Overview',
  'page.missions.details.tab.image': 'Image',
  'page.missions.details.submitted-by': 'Submitted by {user}',
  'page.missions.details.created-by': 'Created by {user}',
  'page.missions.details.btn.reject': 'Reject',
  'page.missions.details.btn.approve': 'Save & approve',
  'page.missions.details.btn.back': 'Back',
  'page.missions.details.btn.complete': 'Complete',
  'page.missions.details.action.description': 'About this mission',
  'page.missions.details.action.considerations': 'Considerations',
  'page.missions.details.action.hero-points': 'Hero points',
  'page.missions.details.action.frequency': 'Frequency',
  'page.missions.details.action.task-type': 'Task type',
  'page.missions.details.action.task-type-loading': 'Loading task types...',
  'page.missions.details.action.task-type-error': 'Error loading task types.',
  'page.missions.details.action.auto-enroll': 'Automatically enroll the user to this mission',
  'page.missions.details.current-image': 'Request image',
  'page.missions.details.current-image.remove-first':
    "In order to change this image, you'll first need to remove this one.",
  'page.missions.details.current-image.no-image':
    'There is no image associated with this request. ',
  'page.missions.details.btn.delete-image': 'Delete image ',
  'page.missions.details.image-upload.success': 'Image uploaded successfully. ',
  'page.missions.details.coming-soon':
    "In future releases you'll be able to edit this information, but for the time being we've focused on image upload.",
}

const missionImageUploadCopy = {
  'page.missions.image-upload.drag-drop': 'Drag and drop an image here',
  'page.missions.image-upload.click-drop': 'Click here to select a file',
  'page.missions.image-upload.upload-new': 'Choose new image',
  'page.missions.image-upload.loading-complete': 'Image uploaded',
  'page.missions.image-upload.error.type': 'Only PNG and JPG files are accepted',
}

const missionBeneficiaryCopy = {
  'page.missions.beneficiary.name': 'Name',
  'page.missions.beneficiary.website': 'Website',
  'page.missions.beneficiary.missing-volunteer-group':
    'This group does not exist in our database. Please complete <orgRegisterForm>this</orgRegisterForm> form to continue.',
}

const missionUserCopy = {
  'page.missions.user.name': 'Name',
  'page.missions.user.email-address': 'Email address',
  'page.missions.user.no-user': 'No user found',
}

const missionRejectionCopy = {
  'page.missions.rejection.reason.title': 'On what grounds are you rejecting this mission?',
  'page.missions.rejection.reason.more-info': 'Additional information (optional)',
  'page.missions.rejection.select-default': 'Select an option',
}

const missionNotifications = {
  'page.missions.notification.failure.reject':
    'There was a problem rejecting this request. Please try again.',
  'page.missions.notification.success.reject.title': 'Mission rejected',
  'page.missions.notification.success.reject.desc':
    'This mission has been rejected and the user has been notified.',
  'page.missions.notification.failure.approve':
    'There was a problem approving this request. Please try again.',
  'page.missions.notification.success.approve.title': 'Mission approved',
  'page.missions.notification.success.approve.desc':
    'This mission has been approved and the user has been notified.',
}

export default {
  ...missionsCopy,
  ...missionDetailsCopy,
  ...missionNotifications,
  ...missionBeneficiaryCopy,
  ...missionUserCopy,
  ...missionRejectionCopy,
  ...missionImageUploadCopy,
  ...RequestsCopy['en-gb'],
}
